import React from 'react';
import ReactDOM from 'react-dom';
import i18n from './i18n';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router} from 'react-router-dom';
import App from './root/App';
import { ThemeProvider, LM_COLOR} from '@iba-team/portal-react-components/dist';
import { I18nextProvider } from 'react-i18next';
import '@iba-team/portal-react-components/dist/assets/output.css';
import { ProjectManagementContext } from '@iba-team/project-management-connectors';
ReactDOM.render(
  <Router>
    <ProjectManagementContext.Provider value={`${process.env.REACT_APP_API_FEATURE_SWITCHER_PROJECT_HASH}`}>
      <I18nextProvider i18n={i18n}>
        <ThemeProvider theme={LM_COLOR}>
          <App/>
        </ThemeProvider>
      </I18nextProvider>
    </ProjectManagementContext.Provider>
  </Router>,
  document.getElementById('root'),
);

reportWebVitals();
